module.exports = __webpack_public_path__ + "img/hr-dark-mud-decal-03.335db25f.png";